import {
  Container,
  Text,
  Box,
  Button,
  Center,
  Input,
  Flex,
  CircularProgress,
  CircularProgressLabel,
  VStack,
  ButtonGroup,
  useToast,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Progress,
  Divider,
  SimpleGrid,
  GridItem
} from "@chakra-ui/react";
import { useVoiceprintStore } from "../store";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import { BASE_URL } from "../constants/api";
import { useState, useEffect } from "react";

import Chart from "./LineChartHigh";
import ChartEnd from "./LineChartEnd";

// Animate continue speaking like Uber places order (fake transition)

// Circular progress bar voice fake animation

const Verified = ({
  progress,
  accessToken,
  setProgress,
  speech_interval,
  setSpeechInterval
}) => {
  const {
    setCurrentStep,
    external_id,
    stream_uid,
    currentStep,
    name,
    setName,
    setStreamId,
    setExternalId,
    setSpeechDuration
  } = useVoiceprintStore();

  const toast = useToast();

  console.log("external id----------------->", external_id);

  const handleEndCall = e => {
    setEndCall(true);
    if (speech_interval) {
      clearInterval(speech_interval);
      setSpeechInterval(null);
    }
    verifyRequest();
  };

  let count = 0;

  const handleTryAgain = e => {
    // toast({
    //   title: "Deleting Current Verification Voiceprint",
    //   status: "loading",
    //   duration: 4000,
    //   isClosable: true
    // });
    e.preventDefault();
    setTryIsLoading(true);

    if (speech_interval) {
      clearInterval(speech_interval);
      setSpeechInterval(null);
    }

    setTimeout(() => {
      setCurrentStep("callSummary");

      setTryIsLoading(false);
    }, 2000);
  };

  const handleDone = e => {
    toast({
      title: "Redirecting To New Voiceprint Screen",
      status: "loading",
      duration: 2000,
      isClosable: true
    });
    setDoneIsLoading(true);

    setTimeout(() => {
      deleteVoiceprint()
        .then(res => {
          if (res.status === 200) {
            setDoneIsLoading(false);
            setCurrentStep("new");
            setName(null);
            setStreamId(null);
            setExternalId(null);
            setSpeechDuration("0");
            setProgress(0);
          }
        })
        .catch(err => {
          setDoneIsLoading(false);
          console.error("End Call Error: ", err);
        });
    }, 2000);
  };

  const [result, setResult] = useState({ status: "", score: 0 });
  const [buttonText, setButtonText] = useState("Get Final Graph");
  // const [buttonText, setButtonText] = useState("Delete"); // For Local Testing
  const [doneIsLoading, setDoneIsLoading] = useState(false);
  const [tryIsLoading, setTryIsLoading] = useState(false);
  const [biometricData, setBiometricData] = useState([]);
  const [callStarted, setCallStarted] = useState(0);
  const [verified, setVerified] = useState(false);
  const [data, setData] = useState();
  const [endCall, setEndCall] = useState(false);

  const deleteVoiceprint = async () => {
    return axios.delete(
      `${BASE_URL}/voice/delete`,
      {
        data: {
          external_uid: external_id
        }
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    );
  };

  const verifyRequest = () => {
    axios
      .post(
        `${BASE_URL}/voice/verify`,
        {
          stream_uid,
          external_uid: external_id
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        if (res.status === 200) {
          toast({
            title: "Verifying Your Voice",
            description:
              "Please wait while we verify your voice against the existing voiceprint",
            status: "loading",
            duration: 2000,
            isClosable: true
          });

          // move forward
          console.log("Voice Enroll Success", res.data);
          axios
            .get(`${BASE_URL}/stream/http/${stream_uid}`, {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            })
            .then(res2 => {
              console.log("Voice Stream Success", res2.data);
              if (res2.status === 200) {
                setResult({ status: res.data.result, score: res.data.score });

                setButtonText("Delete");

                // setCurrentStep("new");
              }
            })
            .catch(err => {
              console.error("Error Closing Stream ", err);
            });
        }
      })
      .catch(err => console.error("Voice Verify Failed: ", err));
  };

  useEffect(() => {
    const interval = setInterval(() => setCallStarted(prev => prev + 1), 1000);

    return () => clearInterval(interval);
  }, []);

  const handleSaveVoiceprint = () => {
    toast({
      title: "Redirecting To New Voiceprint Screen",
      status: "loading",
      duration: 2000,
      isClosable: true
    });

    setTimeout(() => {
      setProgress(0);
      setCurrentStep("new");
    }, 2000);
  };

  const verifyVoiceprint = () => {
    axios
      .post(
        `${BASE_URL}/voice/verify`,
        {
          stream_uid,
          external_uid: external_id
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        if (res.status === 200) {
          count = 0;

          let { score } = res.data;
          setData(score);
          const actualScore = parseFloat(score);

          // Moving Average Testung
          // if (biometricData.length > 0) {
          //   console.log(biometricData, "BIOMETRIC DATA", score, actualScore);
          //   score =
          //     (biometricData[biometricData.length - 1]["actualScore"] +
          //       actualScore) /
          //     2;
          // }

          let manipulatedResult = "";

          if (score >= 0.66) {
            score = 0.8;
            manipulatedResult = "verified";
          } else if (score >= 0.55 && score < 0.66) {
            manipulatedResult = "not sure";
            score = 0.5;
          } else if (score < 0.55) {
            score = 0.2;
            manipulatedResult = "not verified";
          }

          setResult({ status: manipulatedResult, score: res.data.score });

          if (biometricData.length === 0) {
            let tempData = [...biometricData];

            for (let i = 0; i < 3; i++) {
              tempData.push({
                status: res.data.result,
                score: score,
                actualScore: actualScore,
                callStarted: callStarted
              });
            }
            setBiometricData(tempData);
          } else {
            let tempData = [...biometricData];

            tempData.push({
              status: res.data.result,
              score: score,
              actualScore: actualScore,
              callStarted: callStarted
            });
            setBiometricData(tempData);
          }

          // move forward
          // console.log("Voice Enroll Success", res.data);
        }
      })
      .catch(err => console.error("Voice Verify Failed: ", err));
  };

  useEffect(() => {
    if (
      currentStep === "verify" &&
      progress % 6 === 0 &&
      count === 0 &&
      // progress !== "00" &&
      progress !== 0
    ) {
      count = 1;
      setVerified(true);
    }
  }, []);

  useEffect(() => {
    // console.log("biometricData---------->", biometricData);
    // console.log(progress, "Progress", count, "Count");
    if (
      currentStep === "verify" &&
      progress % 1 === 0 &&
      count === 0 &&
      // progress !== "00" &&
      progress !== 0
    ) {
      count = 1;
      setVerified(true);
    }
  }, [progress]);

  useEffect(() => {
    if (verified === true) {
      console.log("verified---->", verified);
      verifyVoiceprint();
      setVerified(false);
    }
  }, [verified]);

  return (
    <Flex w="full">
      <Box w="70%" borderRadius="1px" borderColor="#1b1c1e" p="5">
        {buttonText !== "Delete" ? (
          <SimpleGrid columns={2} spacing={10} w="full">
            <GridItem mt="5%" w="full" colSpan={2}>
              <Chart data={biometricData} endCall={endCall} />
            </GridItem>
          </SimpleGrid>
        ) : null}

        {result.status !== "" && buttonText === "Delete" && (
          <SimpleGrid columns={2} spacing={10} w="full" h="full">
            <GridItem mt="5%" w="full" colSpan={2}>
              <ChartEnd data={biometricData} endCall={endCall} />
            </GridItem>
          </SimpleGrid>
        )}
      </Box>
      <Box w="30%" borderRadius="1px" mt="2%" borderColor="#1b1c1e" p="5">
        <AnimatePresence>
          <motion.div
            style={{ width: "100%" }}
            initial={{ opacity: 0, x: 200 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 200 }}
          >
            <Text fontSize="xl" color="black" mt={-4}>
              Live Call Verification
            </Text>
            <VStack spacing="22px" w="100%" mt={5}>
              <Text fontSize="md" textColor="black">
                Dialing {external_id}
              </Text>
              <CircularProgress
                // value={progress * 20}
                value={100}
                isIndeterminate={result.status === "" ? true : false}
                color={
                  buttonText === "Delete"
                    ? "black"
                    : result.status.toLowerCase() === "verified"
                    ? "green.300"
                    : result.status.toLowerCase() === "not sure"
                    ? "blue.300"
                    : result.status.toLowerCase() === "not verified"
                    ? "red"
                    : "black"
                }
                size="200px"
                thickness="2px"
                alignSelf="center"
                capIsRound
                valueText="xsaa"
              >
                <CircularProgressLabel fontSize="sm">
                  <Text>00:{progress}</Text>
                  <Text color="gray.400">of speaking</Text>
                </CircularProgressLabel>
              </CircularProgress>

              <ButtonGroup w="100%" spacing="15px">
                <Button
                  size="lg"
                  mt="10"
                  w="100%"
                  color="white"
                  bgColor="black"
                  onClick={
                    buttonText === "Get Final Graph"
                      ? handleEndCall
                      : handleDone
                  }
                  isLoading={buttonText === "Delete" && doneIsLoading}
                >
                  {buttonText}
                </Button>
                {buttonText === "Delete" && (
                  <Button
                    size="lg"
                    mt="10"
                    w="100%"
                    color="black"
                    bgColor="white"
                    borderWidth={2}
                    borderColor="black"
                    onClick={handleTryAgain}
                    isLoading={tryIsLoading}
                  >
                    Try Again
                  </Button>
                )}
              </ButtonGroup>

              {buttonText === "Delete" && (
                <Button
                  size="lg"
                  mt="10"
                  w="100%"
                  color="white"
                  bgColor="black"
                  onClick={handleSaveVoiceprint}
                >
                  Save Voiceprint
                </Button>
              )}
            </VStack>
          </motion.div>
        </AnimatePresence>
      </Box>
    </Flex>
  );
};

export default Verified;
